import React, {useState} from 'react';
import {Typography, Box, IconButton, useMediaQuery, useTheme} from '@mui/material';


function AttendanceTimeline({workerStartMinutes, workerEndMinutes, displayStart, displayEnd}) {
    // 📱 wykrywanie mobile (tylko do stylów/ilości etykiet — logika paska bez zmian)
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    //Zakres godzin paska
    const startHour = 0;
    const endHour = 24;
    const totalMinutes = (endHour - startHour) * 60;
    
    //zegar do wyświetlania aktualnego czasu dla paska gdy end jest null
    const now = new Date();
    const currentH = now.getHours();
    const currentM = now.getMinutes();
    const currentMinutes = (currentH - startHour) *60 + currentM;

    //Wyświetlanie paska 
    const leftOffset = (workerStartMinutes / totalMinutes) * 100;
    const barWidth = workerEndMinutes !== null ? 
    ((workerEndMinutes - workerStartMinutes) / totalMinutes) * 100 : 
    ((currentMinutes - workerStartMinutes) / totalMinutes) * 100;
    
    //pasek z godzinami (logika bez zmian — pełny zestaw co 2h)
    const hours = Array.from({length: 13}, (_,i) => startHour + i *2);
    // 📱 na mobile pokazujemy tylko co drugą etykietę (co 4h), żeby się nie nakładały
    const displayedHours = isMobile ? hours.filter((_, i) => i % 2 === 0) : hours;

    //wyświetlenie czerwonego paska ze stanem aktualnym
    const currentPosition = (currentMinutes / totalMinutes) * 100;
   
    return (
        <Box>
            <Box sx={{
                color: 'text.secondary', 
                display: 'flex', 
                justifyContent: 'space-between', 
                mt: 2}}>
                {displayedHours.map(hour =>
                <Typography key={hour} variant='caption' sx={{
                    color: 'text-secondary',
                    fontSize: isMobile ? '0.6rem' : '0.75rem',
                    whiteSpace: 'nowrap',
                    }}>
                    {hour}:00
                </Typography>
                )}
            </Box>
            
            <Box sx={{
                position: 'relative', 
                height: '8px', 
                backgroundColor: '#e0e0e0', 
                borderRadius: '4px'}}>

                <Box sx={{
                    position: 'absolute', 
                    left: `${leftOffset}%`, 
                    top: 0, 
                    height: '8px', 
                    width: `${barWidth}%`, 
                    backgroundColor: '#5d4037', 
                    borderRadius: workerEndMinutes ? '3px' : '3px 0px 0px 3px'
                   }}>
                </Box>
                {workerEndMinutes === null && (
                <Box sx={{
                    position: 'absolute',
                    left: `${currentPosition}%`,
                    top: '-10px',
                    height: '26px',
                    width: '4px',
                    backgroundColor: 'red',
                    borderRadius: '4px'
                    }}> 
                    <Typography variant='body2' sx={{
                        position: 'absolute',
                        left: '-10px',
                        top: '25px',
                        color: 'red',
                        fontSize: '0.75rem',
                        whiteSpace: 'nowrap'
                    }}>teraz</Typography>
                 </Box>
                )}
            </Box>
        </Box>
    )
}

export default AttendanceTimeline;